import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core'
import { MatTableModule } from '@angular/material/table'

@Component({
  selector: 'lib-table-skeleton',
  imports: [MatTableModule],
  templateUrl: './table-skeleton.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './table-skeleton.component.scss',
})
export class TableSkeletonComponent {
  readonly displayedColumns = input.required<{ label: string; key: string }[]>()
  readonly keys = computed(() => this.displayedColumns().map((col) => col.key))

  readonly rows = input(5)
  readonly rowArray = computed(() => Array.from({ length: this.rows() }, () => null))
}
